/** Small deterministic PRNG (mulberry32) so the world layout is reproducible. */
export class Rng {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0;
  }

  next(): number {
    this.state = (this.state + 0x6d2b79f5) >>> 0;
    let t = this.state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  range(min: number, max: number): number {
    return min + this.next() * (max - min);
  }

  int(min: number, max: number): number {
    return Math.floor(this.range(min, max + 1));
  }

  pick<T>(items: readonly T[]): T {
    return items[Math.floor(this.next() * items.length)];
  }

  chance(p: number): boolean {
    return this.next() < p;
  }
}

export const random = {
  range: (min: number, max: number) => min + Math.random() * (max - min),
  int: (min: number, max: number) => Math.floor(min + Math.random() * (max - min + 1)),
  pick: <T,>(items: readonly T[]): T => items[Math.floor(Math.random() * items.length)],
  chance: (p: number) => Math.random() < p,
};
